import ReportsTabs from "./ReportsTabs";

const Reports = () => {
  return (
    <div className="flex h-full w-full overflow-auto">
      <div className="flex flex-col w-full h-full bg-background overflow-hidden">
        <ReportsTabs />
      </div>
    </div>
  );
};

export default Reports;
